import { IconX } from "@tabler/icons-react";
import toast from "react-hot-toast";
import { useNotificationStatusMutation } from "../../apis/notificationApis";
import { useEffect } from "react";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  notification: any;
  refetch: () => void;
};

const BannerNotificationModal = ({ isOpen, onClose, notification, refetch }: Props) => {
  const { mutate: statusMutate, isPending: isStatusPending } = useNotificationStatusMutation(notification?.id);

  const handleClose = () => {
    if (!notification?.seen) {
      statusMutate(
        { seen: true },
        {
          onSuccess: (data: any) => {
            onClose()
            refetch();
          },
          onError: (error: any) => {
            console.log(error, "error");
            toast.error(`${error}`);
          },
        }
      )
    }
    onClose()
  };

  if (!isOpen) return null;

  return (
    <div
      className="bg-black/70 fixed inset-0 flex items-center justify-center z-50"
      role="dialog"
      aria-modal="true"
    >
      <div className="bg-[#F7F6F2] rounded-xl w-[768px] shadow-lg overflow-hidden">
        {/* Header */}
        <div className="flex items-center justify-between gap-4 p-4 border-b border-black/10">
          <p className="font-medium text-lg">
            {notification?.title}
          </p>
          <button
            onClick={handleClose}
            className="rounded-full p-1 hover:bg-black/10 transition"
            aria-label="Close"
          >
            <IconX size={20} />
          </button>
        </div>

        {/* Banner image */}
        <div className="flex justify-center">
          <img
            src={notification?.image || "/img/notification-img.png"}
            alt="Promotion Banner"
            className="aspect-[4/3] object-cover w-[500px] h-[500px]"
          />
        </div>

        <p className="font-medium text-lg px-2">
          {notification?.message}
        </p>
      </div>
    </div>
  );
}

export default BannerNotificationModal;